import { status } from "../constants/status"

export default function getDeployementData(modelName) {
    return [
        {
            key: 6,
            title: modelName,
            last_trained: '2024-05-13-10:40:03',
            base_model_name: 't5_base',
            dataset_name: 'customer-support-chatbot',
            dataset_entries: '183521',
            dataset_size: '12GB',
            status: status.serving_ready,
            thumbs_up: 0,
            thumbs_down: 0,
            my_golden_data: 70,
            test_internal: 85.4,
        },
    ]
}